import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import AddNewComponent from 'app/AddNewComponent/components/AddNewComponent';
import ComponentSearch from 'app/ComponentSearch/container';
import SearchTab from 'app/Explorer/components/SearchTab';
import { PrimaryButton, ClearButton } from 'ui/Components';
import { createNewComponentObject } from 'utils/factory';

/**
 * add new or existing components to a container component
 * renders two buttons that open modals to accomplish either
 */
export default class AttachChildModal extends Component {
  static propTypes = {
    allowedChildComponents: propTypes.arrayOf(propTypes.string),
    addFilter: propTypes.func.isRequired,
    className: propTypes.string,
    clearSearch: propTypes.func.isRequired,
    componentDetails: propTypes.object.isRequired,
    componentsList: propTypes.array,
    contractMap: propTypes.object.isRequired,
    cwdSiteRoot: propTypes.string,
    'data-test-id': propTypes.string,
    isReadonly: propTypes.bool,
    lanId: propTypes.string,
    onComponentSelected: propTypes.func.isRequired
  };

  static defaultProps = {
    allowedChildComponents: [],
    componentsList: [],
    className: '',
    cwdSiteRoot: '',
    'data-test-id': '',
    isReadonly: false,
    lanId: ''
  };

  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    this.addNewComponent = this.addNewComponent.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  /**
   * attach a new component to the container component
   * @param {object} opts - function options
   * @param {string} opts.componentVariation - component variation for the new component
   * @param {object} opts.renderingEnv - rendering env object for the new component
   */
  addNewComponent({ componentVariation, renderingEnv }) {
    const { contractMap, cwdSiteRoot, lanId, onComponentSelected } = this.props;

    const component = createNewComponentObject({
      componentVariation,
      cwdSiteRoot,
      renderingEnv,
      canvasContract: contractMap[componentVariation],
      userLanId: lanId
    });

    onComponentSelected(component);
  }

  /**
   * close the modal and clear container and search redux state
   */
  closeModal() {
    const { clearSearch } = this.props;
    this.toggle();
    clearSearch();
  }

  /**
   * toggle the modal state
   */
  toggle() {
    // including this eslint-disable below because using the previous state (ps) param with setState did not work here.
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const {
      addFilter,
      allowedChildComponents,
      className,
      componentDetails,
      componentsList,
      onComponentSelected,
      'data-test-id': testId,
      isReadonly
    } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={`d-inline-flex ${className}`} data-test-id={testId}>
        <PrimaryButton
          disabled={isReadonly}
          onClick={this.toggle}
          data-test-id="attach-child-modal-insert-existing"
        >
          + Insert Existing
        </PrimaryButton>
        <Modal isOpen={isOpen} toggle={this.closeModal}>
          <ModalHeader>Search for a Component</ModalHeader>
          <ModalBody data-test-id="attach-child-modal-body">
            <ComponentSearch
              hideLists={false}
              isContainer
              onResultClick={onComponentSelected}
              onFinish={this.closeModal}
            />
            <SearchTab
              addFilter={addFilter}
              componentsList={componentsList}
              hidePageSelection
              isContainer
              onFinish={this.closeModal}
              onResultClick={onComponentSelected}
            />
          </ModalBody>
          <ModalFooter>
            <ClearButton
              onClick={this.closeModal}
              data-test-id="attach-child-modal-button-cancel"
            >
              Cancel
            </ClearButton>
          </ModalFooter>
        </Modal>
        <AddNewComponent
          className="ml-3"
          componentsList={allowedChildComponents}
          newComponentSelected={this.addNewComponent}
          pageType={componentDetails?.RenderingEnv?.PageType}
          pageTemplateName={componentDetails?.RenderingEnv?.PageTemplateName}
          buttonText="+ Add New"
          isReadonly={isReadonly}
          data-test-id="attach-child-modal-add-new"
        />
      </div>
    );
  }
}
